import { render, staticRenderFns } from "./user-menu-mobile.vue?vue&type=template&id=457d7d65&scoped=true"
import script from "./user-menu-mobile.vue?vue&type=script&lang=ts"
export * from "./user-menu-mobile.vue?vue&type=script&lang=ts"
import style0 from "./user-menu-mobile.vue?vue&type=style&index=0&id=457d7d65&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d7d65",
  null
  
)

export default component.exports